import api from '../../../../utils/api';

export interface Agreement {
    requisitionId: string,
    authorisationLink: string,
}

const generateAgreement = async (
    institutionId: string,
    homeseekerId: string,
    userLanguage: string
): Promise<Agreement[]> => {
    return await api.getWithoutAuth(
        `api/screening/income-verification/provide-transactions/generate-agreement`, {
            'institutionId': institutionId,
            'homeseekerId': homeseekerId,
            'userLanguage': userLanguage
        });
}

export default generateAgreement;
